import React from 'react'
import { Link } from 'gatsby'
import LogoWhite from '../assets/LogoWhite'
import LogoOmidagroup from '../assets/LogoOmidagroup'
import useMenu from '../context/menu.hook'
import { useLangContext } from '../context/lang.context'
import { sSection, s, colors, alpha } from '../style'

import EmailIcon from '../assets/emailIcon'
import PhoneIcon from '../assets/phoneIcon'
import LocationIcon from '../assets/locationIcon'
import FacebookIcon from '../assets/facebookIcon'
import LinkedinIcon from '../assets/linkedinIcon'
import YoutubeIcon from '../assets/youtubeIcon'
import InstagramIcon from '../assets/instagramIcon'

const socialMedia = [
  {
    name: 'email',
    link: 'mailto:hello@omidatrade.pl',
    icon: () => <EmailIcon />,
  },
  {
    name: 'phone',
    link: 'tel:+48587418814',
    icon: () => <PhoneIcon />,
  },
  {
    name: 'address',
    link: 'https://www.google.com/maps/dir/54.389397,18.6280198/omida+logistics/',
    icon: () => <LocationIcon />,
  },
  {
    name: 'facebook',
    link: 'https://www.facebook.com/omidatrade/',
    icon: () => <FacebookIcon />,
  },
  {
    name: 'linkedin',
    link: 'https://www.linkedin.com/company/omida-trade/',
    icon: () => <LinkedinIcon />,
  },
  {
    name: 'youtube',
    link: 'https://www.youtube.com/channel/UCeaemAUE3MdbHoFRD95DgfA',
    icon: () => <YoutubeIcon />,
  },
  {
    name: 'instagram',
    link: 'https://www.instagram.com/omidatsl/',
    icon: () => <InstagramIcon />,
  },
]

const copyrights = {
  pl: `<div><div>Copyright ©${' '}<strong>Omida VLS Sp. z o.o. 2010 - ${new Date().getFullYear()}</strong></div></div><span> | </span>Wszelkie prawa zastrzeżone`,
  en: `<div><div>Copyright ©${' '}<strong>Omida VLS Sp. z o.o. 2010 - ${new Date().getFullYear()}</strong></div></div><span> | </span>All rights reserved`,
  zh: `<div><div>版权所有 ©${' '}<strong>Omida VLS Sp. z o.o. 2010 - ${new Date().getFullYear()}</strong></div></div><span> | </span>保留所有权利`,
}

const vatNumber = {
  pl: 'NIP',
  en: 'TAX',
  zh: '税号'
}

const footerLinks = [
  {
    name: {
      pl: 'Dokumenty',
      en: 'Documents',
      zh: '文件',
    },
    url: {
      pl: `/documenty/`,
      en: `/documents/`,
      zh: `/documents-zh/`
    }
  },
  {
    name: {
      pl: 'Certyfikaty',
      en: 'Certificates',
      zh: '证书',
    },
    url: {
      pl: `/#certificates`,
      en: `/#certificates`,
      zh: `/#certificates`
    }
  },
  {
    name: {
      pl: 'Polityka Firmy',
      en: 'Company Policies',
      zh: '公司政策',
    },
    url: {
      pl: `/policy/`,
      en: `/policy/`,
      zh: `/policy/`
    }
  },
  {
    name: {
      pl: 'Ochrona Danych',
      en: 'Data protection',
      zh: '数据保护',
    },
    url: {
      pl: `/privacy/`,
      en: `/privacy/`,
      zh: `/privacy-zh/`
    }
  },
  {
    name: {
      pl: 'Zasady Ochrony Danych',
      en: 'Privacy Policy',
      zh: '隐私政策',
    },
    url: {
      pl: `/pdf/zasady-ochrony-danych.pdf`,
      en: `/pdf/zasady-ochrony-danych.pdf`,
      zh: `/pdf/zasady-ochrony-danych.pdf`
    }
  },
  
]

const Footer = () => {
  const { lang, toggleLang } = useLangContext()
  const { footer } = useMenu()

  return (
    <footer css={sFooter}>
      <div css={sInner}>
        <div css={sSection1}>
          <div css={sLogos}>
            <Link to='/' css={sLogo}>
              <LogoWhite />
            </Link>
          </div>
          <div css={sSocialMedia}>
            {socialMedia.map(({ link, icon, name }, id) => (
              <a
                href={link}
                key={id}
                target='_blank'
                rel='noreferrer noopener'
                title={name}>
                {icon()}
              </a>
            ))}
          </div>
        </div>
        <div css={sSectionBottom}>
          <span className='footer-bottom-title'>
            Omida VLS Sp. z o.o.
          </span>
          <div css={sBottomGrid}>
            <div className='footer-bottom-external'>
              <a
                href={socialMedia.find(({ name }) => name === 'address').link}
                rel='noreferrer noopener'
                target='_blank'>
                Aleja Grunwaldzka 472C,
                <br /> 80-309 Gdańsk, Poland
              </a>
            </div>
            <div className='footer-bottom-external'>
              <a href={socialMedia.find(({ name }) => name === 'email').link}>
                hello@omidatrade.pl
              </a>
              <a href={socialMedia.find(({ name }) => name === 'phone').link}>
                +48 58 741 88 14
              </a>
            </div>
            <div className='footer-bottom-external'>
              <span>KRS: 0000459017</span>
              <span>{vatNumber[lang]}: 5851466250</span>
            </div>
            <div className='footer-bottom-internal'>
              {footerLinks.map(({ name, url }, id) => (
                <Link key={id} to={url[lang]}>{name[lang]}</Link>
              ))}
            </div>
            <a
              href='https://omidagroup.pl'
              target='_blank'
              rel='noreferrer noopener'
              css={[sLogo, sLogoGroup]}>
              <LogoOmidagroup />
            </a>
          </div>
        </div>
        <div css={sSectionCopyright} dangerouslySetInnerHTML={{__html: copyrights[lang]}} />
      </div>
    </footer>
  )
}

const sBottomGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  '& > div': {
    display: 'flex',
    flexDirection: 'column',
    [s.md_down]: {
      marginBottom: '4rem',
    },
    [s.sm_down]: {
      marginBottom: '2rem',
    },
  },
  color: 'white',
  [s.xs]: { gridTemplateColumns: 'repeat(1, 1fr)' },
  [s.sm]: { gridTemplateColumns: 'repeat(2, 1fr)' },
  [s.md]: { gridTemplateColumns: 'repeat(3, 1fr)' },
  [s.lg]: { gridTemplateColumns: 'repeat(5, 1fr)' },
}

const sSectionBottom = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderTop: `1px solid ${colors.white.concat(alpha[16])}`,
  borderBottom: `1px solid ${colors.white.concat(alpha[16])}`,
  [s.sm_down]: {
    margin: '3rem 2rem 0rem',
    padding: '4rem 0 3rem',
  },
  [s.xs]: {
    margin: '3rem 2rem 1rem',
    padding: '5rem 0 3rem',
  },
  [s.md]: {
    margin: '4rem 4rem',
    padding: '6rem 0 2rem',
  },
  [s.lg]: {
    margin: '4rem 4rem',
    padding: '8rem 0',
  },

  '.footer-bottom-title': {
    fontSize: '1rem',
    color: colors.white,
    marginBottom: '2rem',
    fontWeight: 700,
    letterSpacing: '-0.05em',
  },

  '.footer-bottom-external': {
    a: {
      transition: 'color 0.2s ease-out',
    },
    'a, span': {
      fontSize: '0.875rem',
      color: colors.white.concat(alpha[60]),
      lineHeight: '2em',
    },
    'a:hover': {
      color: colors.brandLight,
    },
  },
  '.footer-bottom-internal': {
    a: {
      transition: 'color 0.2s ease-out',
      fontSize: '0.75rem',
      paddingBottom: '0.5rem',
      color: colors.white.concat(alpha[30]),
    },
    'a:hover': {
      color: colors.brandLight,
    },
  },
}

const sSectionCopyright = {
  lineHeight: '2em',
  fontSize: '0.75rem',
  marginTop: '4rem',
  color: colors.white.concat(alpha[30]),
  strong: {
    color: colors.white.concat(alpha[60]),
    [s.sm]: { marginLeft: '0.5rem' },
  },

  a: {
    textDecoration: 'underline',
  },

  span: {
    color: colors.white.concat(alpha[16]),

    [s.sm]: { margin: '0 0.5rem' },
  },
  [s.sm_down]: { padding: '0 2rem' },

  [s.xs]: {
    marginTop: '3rem',
    display: 'flex',
    flexDirection: 'column',
    span: {
      display: 'none',
    },
    '& > div': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  [s.sm]: {
    display: 'flex',
    flexWrap: 'wrap',
    whiteSpace: 'nowrap',
    div: { display: 'flex', flexWrap: 'nowrap' },
  },
  [s.md]: {
    padding: '0 4rem',
  },
}

const sSocialMedia = {
  display: 'flex',

  a: {
    transition: 'color 0.2s ease-out',
    color: 'white',
    paddingLeft: '2rem',
    svg: {
      width: '1.25rem',
      height: '1.25rem',
    },
    '&:hover': {
      color: colors.brandLight,
    },
  },

  [s.sm_down]: {
    marginTop: '4rem',
    alignItems: 'center',
    a: {
      padding: '0 3rem 0 0',
    },
  },
  [s.xs]: {
    a: {
      padding: '0 1.5rem 0 0',
    },
  },
  [s.ss]: {
    a: {
      padding: '0 1.25rem 0 0',
    },
  },
}

const sSublink = {
  listStyle: 'none',
  // transition: 'color 0.2s ease-out',

  color: colors.white.concat(alpha[30]),
  fontSize: '0.75rem',

  fontWeight: 400,
  letterSpacing: '0em',
  '&:hover': {
    color: colors.brandLight,
  },
}

const sGrid = {
  display: 'grid',
  maxWidth: '100vw',
  gridAutoRows: `repeat(auto, 1fr)`,
  padding: '2rem',
  [s.sm_down]: {
    padding: '1rem',
    marginTop: '2rem',
  },
  [s.xs]: {
    gridTemplateColumns: `repeat(2, 1fr)`,
  },
  [s.sm]: {
    gridTemplateColumns: `repeat(2, 1fr)`,
  },
  [s.md]: {
    gridTemplateColumns: `repeat(4, 1fr)`,
    marginTop: '4rem',
  },
}

const sLink = {
  borderRadius: '1rem',
  transition: 'background-color 0.2s ease-out',
  fontWeight: 700,
  letterSpacing: '-0.05em',
  display: 'flex',
  flexDirection: 'column',
  listStyle: 'none',
  color: 'white',
  padding: '2rem',
  [s.sm_down]: {
    padding: '1rem',
  },
  fontSize: '0.875rem',
  '.footer-link': {
    // paddingBottom: '0.5rem',
    // transition: 'color 0.2s ease-out',
    '&:hover': {
      color: colors.brandLight,
    },
  },
  '&:hover': {
    backgroundColor: colors.greyDark.concat(alpha[50]),
  },
}

const sFooter = {
  background: `linear-gradient(to bottom, ${colors.text}, ${colors.greyDarker})`,
  width: '100vw',
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 1010, // more than menu
}

const sSection1 = {
  maxWidth: '100vw',
  display: 'flex',
  justifyContent: 'space-between',
  [s.sm_down]: { padding: '0 2rem', flexDirection: 'column' },
  [s.md]: { padding: '0 4rem ' },
}

const sInner = {
  ...sSection,
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 0,
  marginTop: 0,
  [s.sm_down]: { padding: '4rem 0', marginTop: 0 },
  [s.md]: { padding: '8rem 0 ' },
}

const sLogos = {
  display: 'grid',
  gridTemplateColumns: `repeat(2, 1fr)`,
  width: '50%',
  [s.sm_down]: {
    width: '100%',
  },
  [s.xs]: {
    gridTemplateColumns: `repeat(1, 1fr)`,
  },
}

const sLogo = {
  color: 'white',
  display: 'flex',
  transition: 'color 0.2s ease-out',
  position: 'relative',
  top: 0,
  left: 0,
  width: 150,
  svg: {
    width: 'max-content',
    display: 'flex',
    height: 36,
    color: 'currentColor',
  },
  path: {
    fill: 'currentColor',
  },
  polygon: {
    fill: 'currentColor',
  },
  rect: {
    fill: 'currentColor',
  },
  '&:hover': {
    color: colors.brandLight,
    path: {
      fill: colors.brandLight,
    },
    polygon: {
      fill: colors.brandLight,
    },
    rect: {
      fill: colors.brandLight,
    },
  },
}

const sLogoGroup = {
  padding: 0,
  [s.sm_down]: { padding: 0 },
  [s.xs]: { padding: 0, marginTop: '1rem' },
  svg: {
    height: 52,
  },
}

export default Footer
